exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active[data-v-346e866f]{background:rgba(0,93,101,.4980392157)!important}", ""]);

// exports
